module.exports = __webpack_public_path__ + "categories/icon-truck-809cd055b4bdc76c4604d1f0bbd39741.svg";